export default "__VITE_ASSET__kxa1P7l___"